import { publicSchedulingRoutes } from 'constants/routes';
import { Route, Routes } from 'react-router-dom';
import PublicScheduling from 'views/PublicScheduling/PublicScheduling';

const PUBLIC_SCHEDULING_ROOT = publicSchedulingRoutes.root.getUrl();

/**
 * Whether a pathname belongs to the public, login-free scheduling namespace.
 * App.tsx forks on this before mounting the authenticated provider tree.
 * Segment-aware on purpose: `/schedulingx` and `/roles/scheduling` are not
 * public routes.
 */
export const isPublicSchedulingRoute = (pathname: string): boolean =>
  pathname === PUBLIC_SCHEDULING_ROOT ||
  pathname.startsWith(`${PUBLIC_SCHEDULING_ROOT}/`);

/**
 * Public counterpart of AppSwitch. No PrivateRoute, no auth/user/theme
 * contexts — the candidate arrives from an emailed link without a session.
 * Anything under /scheduling without a token renders the page's not-found
 * state rather than the authenticated app.
 */
function PublicSchedulingSwitch() {
  return (
    <Routes>
      <Route
        path={publicSchedulingRoutes.book.path}
        element={<PublicScheduling />}
      />
      <Route
        path={publicSchedulingRoutes.root.path}
        element={<PublicScheduling />}
      />
    </Routes>
  );
}

export default PublicSchedulingSwitch;
